export default "__VITE_ASSET__CyH1bTf2__"